(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/transaction-history-no-teams.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/transaction-history-no-teams.js');

'use strict';

const {
  ReactButton: Button
} = svs.ui;
const {
  ReactIcon: Icon
} = svs.ui;
const TransactionHistoryNoTeams = () => {
  const onCreateTeam = () => {
    svs.utils.url.navigate(svs.utils.url.makeInternal("".concat(svs.core.urlMapping.get('playTogetherTeams'), "/skapa"), svs.core.urlMapping.get('startPage')));
  };
  return React.createElement("div", {
    className: "margin-xs-top-2 align-center"
  }, React.createElement(Icon, {
    icon: "help-2",
    size: "700"
  }), React.createElement("div", {
    className: "margin-xs-top-2"
  }, "Det finns ingen historik eftersom du inte \xE4r med i n\xE5got lag."), React.createElement("div", {
    className: "margin-xs-top-2"
  }, React.createElement(Button, {
    block: true,
    focus: true,
    onClick: onCreateTeam,
    size: 300
  }, "Skapa nytt lag")));
};
svs.arena.pages.teams.components.TransactionHistoryNoTeams = TransactionHistoryNoTeams;

 })(window);